import { ComponentHelper } from "../../core/util/componentHelper.js";
import { Button } from "../../core/components/button.js";
import { TextBox } from "../../core/components/textBox.js";
import { CheckBox } from "../../core/components/checkBox.js";
import { Helper } from "../../core/util/helper.js";
import { Config } from "../../core/config/config.js";
import { RightDrawerContainer } from "../../core/components/rightDrawerContainer.js";
import { Entity } from "../../core/components/commonApp.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
import ReactDOM from "react-dom";

export class ResultPreview extends React.Component<{ info: DistributionInfo }, { mode: "general" | "detail" }> {
    constructor(props) {
        super(props)
        this.state = {
            mode: "general"
        }
    }
    private _renderRightDrawerComponent = () => {


        const entity: Entity = {
            IsNew: true,
            RecordRight: {
                CanRead: true, CanWrite: true
            },
            IsWatchable: false,
            IsWatched: false
        };
        return (<RightDrawerContainer
            moduleName={""}
            appName={""}
            visible={true}
            width={400}
            entity={entity}
            renderAlways={true}
            multipleComponents={[{
                moduleName: "app/core/components/iframe",
                iconName: "question-circle",
                renderAlways: true,
                props: {
                    url: "{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}"
                }
            }]}
        />);
    }

    private renderButton = () => {
        return (
            <>
                <div
                    style={{ width: "175px", marginRight: "15px" }}
                    className={"assignmentDistribution__footer__item assignmentDistribution__footer__item--active"}
                    onClick={() => {
                        this.setState({ mode: this.state.mode === "general" ? "detail" : "general" })
                    }}
                >
                    <label>{this.state.mode === "general" ? Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.ShowDetails") : Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.ShowGeneral")}</label>
                </div>
            </>
        );
    }

    render() {
        return (
            <>
                {this._renderRightDrawerComponent()}
                <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <div style={{ display: "flex", flexDirection: "row-reverse", justifyContent: "space-between" }}>
                        {this.renderButton()}
                        <div id="ResultPreviewHeader" />
                    </div>
                    {this.state.mode == "general" ? <GeneralView info={this.props.info} /> : <DetailView info={this.props.info} />}
                </div>
            </>
        );
    }
}

export interface DistributionInfo {
    Resources: TreeResource[];
    NotAssignedAssignments: TreeAssignment[];
    DaysCount: number;
    Start: string;
    End: string;

    DistributedStatistic: Statistic;
    NonDistributedStatistic: Statistic;
}

interface TreeResource extends ITreeItem {
    ResNo: string;
    Name: string;
    AssignedDays: TreeAssignedDay[];
    MainGroup: string;
    Group: string;
    Point: Point
}

interface TreeAssignedDay extends ITreeItem {
    Day: string | Date;
    Assignments: TreeAssignment[];
    Statistic: Statistic;
    Flag?: string
    Capacity: number;
    Available: boolean;
    Home: Point;

    ReturnToHome: boolean;
    StartAtHome: boolean;
}

interface Statistic {
    TotalDrivingHours: number;
    TotalDistanceKm: number;
    TotalWorkingHours: number;
    CountAssignments: number;
}

interface TreeAssignment extends ITreeItem {
    Id: string;
    Title: string;
    AdrNr: string;
    Address: string;
    AddressLocation: string;
    AddressPostal: string;
    WorkingHours: number;
    Flag: string;
    Point: Point;
    Pos: number;

    DayPart: boolean;
    PartNo: number;
    PartsCount: number;
}

interface Point {
    Lat: number;
    Long: number;
    Sexagesimal: string;
}

interface ITreeItem {
    Type: TreeType;
}

enum TreeType {
    Resource, Day, Assignment
}

class GeneralView extends React.Component<{ info: DistributionInfo }, any>{

    constructor(props) {
        super(props)
    }
    render() {

        const [expl1, expl2] = InfoHelper.generateDistributionExplanation();
        return (
            <div style={{ display: "grid", gridTemplateColumns: "15px repeat(4, 150px) 15px", gridTemplateRows: "50px repeat(3, 30px) 10px repeat(8, 30px)", flex: 1 }}>
                <div style={{ gridColumn: "2/7", fontSize: "35px" }}> {Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.GeneralInfos")} </div>
                <div style={{ gridArea: "2/2/3/4", fontSize: "20px", display: "flex", alignItems: "center" }}>{kendo.toString(kendo.parseDate(this.props.info.Start), 'd')} - {kendo.toString(kendo.parseDate(this.props.info.End), 'd')}</div>
                <div style={{ gridArea: "3/2/4/4", fontSize: "20px", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.Days").replace("{value}", this.props.info.DaysCount.toString())}</div>
                <div style={{ gridArea: "4/2/5/5", fontSize: "20px", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.ResourcesScheduled").replace("{value}", this.props.info.Resources.length.toString())}</div>


                <div style={{ gridArea: "6/2/7/4", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.ScheduledTravelTimes")}</div>
                <div style={{ gridArea: "6/4/7/5", display: "flex", alignItems: "center" }}>{InfoHelper.convertToTime(this.props.info.DistributedStatistic.TotalDrivingHours)}</div>


                <div style={{ gridArea: "7/2/8/4", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.ScheduledDistance")}</div>
                <div style={{ gridArea: "7/4/8/5", display: "flex", alignItems: "center" }}>{InfoHelper.toFancyString(this.props.info.DistributedStatistic.TotalDistanceKm) + " km"}</div>

                <div style={{ gridArea: "8/2/9/4", display: "flex", alignItems: "center" }}>
                    {Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.AssignmentsToScheduled")}
                </div>
                <div style={{ gridArea: "9/2/10/6" }}>
                    {InfoHelper.generateDistributedBarChart(this.props.info.DistributedStatistic.CountAssignments, this.props.info.NonDistributedStatistic.CountAssignments, (value: number) => { return value.toString() })}
                </div>

                <div style={{ gridArea: "10/2/11/4", display: "flex", alignItems: "center" }}>
                    {Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.TotalWorkingHours")}
                </div>
                <div style={{ gridArea: "11/2/12/6" }}>
                    {InfoHelper.generateDistributedBarChart(this.props.info.DistributedStatistic.TotalWorkingHours, this.props.info.NonDistributedStatistic.TotalWorkingHours, InfoHelper.convertToTime)}
                </div>

                <div style={{ gridArea: "12/2/14/4", display: "flex", alignItems: "center" }}>
                    {expl1}
                </div>

                <div style={{ gridArea: "12/4/14/6", display: "flex", alignItems: "center" }}>
                    {expl2}
                </div>
            </div>
        );
    }
}

class DetailView extends React.Component<{ info: DistributionInfo }, { selectedItem: ITreeItem }>{

    constructor(props) {
        super(props)
        this.state = {
            selectedItem: null
        }
    }

    private onItemSelect = (item: ITreeItem) => {
        this.setState({ selectedItem: item })
    }

    render() {
        return (
            <div style={{ width: "100%", flex: 1, display: "flex" }}>
                <Tree distributionInfo={this.props.info} onSelect={this.onItemSelect} />
                <ItemInfo item={this.state.selectedItem} />
            </div>
        );
    }
}

class Tree extends React.Component<TreeProps, any>{
    private flatTreeItems: StringKeyDictionary<ITreeItem> = {};
    private treeView: kendo.ui.TreeView = null;
    private treeDiv: HTMLDivElement;
    private treeData: TreeItem[] = [];

    constructor(props) {
        super(props);
        this.initApp();
    }

    private initApp = () => {
        const [items, flat] = TreeViewHelper.MapDistributionInfoToTree(this.props.distributionInfo);
        this.treeData = items as TreeItem[];
        this.flatTreeItems = flat as StringKeyDictionary<ITreeItem>;
    }

    private initTree = () => {
        let data: TreeItem[] = JSON.parse(JSON.stringify(this.treeData));
        data = TreeViewHelper.FilterTreeItems(data, "", true);
        this.treeView = $(this.treeDiv).kendoTreeView({
            dataSource: data,
            select: this.onSelect,
            expand: (e) => {
                const id: string = $(this.treeDiv).data('kendoTreeView').dataItem(e.node).id;
                this.updateTreeItems(id, true);
            },
            collapse: (e) => {
                const id: string = $(this.treeDiv).data('kendoTreeView').dataItem(e.node).id;
                this.updateTreeItems(id, false);
            }
        }).data("kendoTreeView")
    }

    private updateTreeItems = (id: string, expanded: boolean) => {
        const enumerate = (item: TreeItem) => {
            if (id === item.id) {
                item.expanded = expanded;
            } else if ((Helper.hasValue(item.items) && item.items.length > 0)) {
                item.items.forEach(enumerate);
            }
        }
        this.treeData.forEach(enumerate);
    }

    private onSelect = (e) => {
        const id: string = $(this.treeDiv).data('kendoTreeView').dataItem(e.node).id;
        this.props.onSelect(this.flatTreeItems[id]);
    }

    private renderFilter = () => {
        const filter = (
            <>
                <Filter
                    onFilterChange={this.onFilterChange}
                    expandAll={this.expandAll}
                    collapseAll={this.collapseAll}
                />
            </>
        );
        return ReactDOM.createPortal(filter, document.getElementById("ResultPreviewHeader"));
    }

    componentDidMount() {
        this.initTree();
    }

    private onFilterChange = (filter: string, onlyAssignments: boolean) => {
        let data: TreeItem[] = JSON.parse(JSON.stringify(this.treeData));
        data = TreeViewHelper.FilterTreeItems(data, filter, onlyAssignments)
        this.treeView.setDataSource(data as any);
    }

    private expandAll = () => {
        this.treeView.expand(".k-item");
    }

    private collapseAll = () => {
        this.treeView.collapse(".k-item");
    }

    render() {
        return (
            <div style={{ width: "45%", height: "100%" }}>
                {this.renderFilter()}
                <div style={{ height: "100%" }} ref={(ref) => { this.treeDiv = ref; }} id="treeview" />
            </div>
        );
    }
}

interface TreeProps {
    distributionInfo: DistributionInfo;
    onSelect: (item: ITreeItem) => void;
}

interface TreeItem {
    id: string;
    text: string;
    expanded: boolean;
    spriteCssClass: string;
    items: TreeItem[];
}

class TreeViewHelper {

    public static MapDistributionInfoToTree = (distributionInfo: DistributionInfo) => {
        const flatTreeItems: StringKeyDictionary<ITreeItem> = {};
        const items: TreeItem[] = distributionInfo.Resources.map((res) => {
            const resId = kendo.guid();
            flatTreeItems[resId] = res;
            const resItem: TreeItem = {
                id: resId,
                expanded: false,
                spriteCssClass: null,
                text: `${res.ResNo} - ${res.Name}`,
                items: res.AssignedDays.map((day) => {
                    const dayId = kendo.guid();
                    flatTreeItems[dayId] = day;
                    const dayItem: TreeItem = {
                        expanded: false,
                        id: dayId,
                        spriteCssClass: null,
                        text: kendo.toString(kendo.parseDate(day.Day.toString()), 'd'),
                        items: day.Assignments.map((assignment) => {
                            const assignmentId = kendo.guid();
                            flatTreeItems[assignmentId] = assignment;
                            const assignmentItem: TreeItem = {
                                id: assignmentId,
                                expanded: false,
                                spriteCssClass: null,
                                items: [],
                                text: `${assignment.Id} - ${assignment.Title} - ${assignment.Address} - ${assignment.AddressLocation}`
                            }
                            return assignmentItem;
                        })
                    }
                    return dayItem;
                })
            };
            return resItem;
        })
        items.push({
            expanded: false,
            id: kendo.guid(),
            spriteCssClass: null,
            text: Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.NotAssignedAssignments"),
            items: distributionInfo.NotAssignedAssignments.map((assignment) => {
                const id = kendo.guid();
                flatTreeItems[id] = assignment;
                const item: TreeItem = {
                    expanded: true,
                    id: id,
                    items: [],
                    spriteCssClass: null,
                    text: `${assignment.Id} - ${assignment.Title} - ${assignment.Address} - ${assignment.AddressLocation}`
                }
                return item;
            })
        });
        return [items, flatTreeItems]
    }

    public static FilterTreeItems = (treeItems: TreeItem[], filter: string, onlyAssignments: boolean) => {
        const removeItemlessItems = (item: TreeItem) => {
            return item.items.length > 0;
        }
        if (onlyAssignments) {
            for (let i = 0; i < treeItems.length - 1; i++) {
                treeItems[i].items = treeItems[i].items.filter(removeItemlessItems)
            }
            treeItems = treeItems.filter(removeItemlessItems);
        }
        if (!Helper.isNullOrEmpty(filter)) {
            filter = filter.toLowerCase();
            for (let i = 0; i < treeItems.length - 1; i++) {
                for (let j = 0; j < treeItems[i].items.length; j++) {
                    treeItems[i].items[j].items = treeItems[i].items[j].items.filter((item) => {
                        return item.text.toLowerCase().includes(filter) || treeItems[i].text.toLowerCase().includes(filter);
                    })
                }
                treeItems[i].items = treeItems[i].items.filter((item) => {
                    return item.items.length > 0 || treeItems[i].text.toLowerCase().includes(filter);
                })
            }
            treeItems[treeItems.length - 1].items = treeItems[treeItems.length - 1].items.filter((item) => {
                return item.text.toLowerCase().includes(filter)
            });
            treeItems = treeItems.filter(removeItemlessItems);
        }
        return treeItems as any;
    }
}

class Filter extends React.Component<FilterProps, FilterState>{
    private factory = ComponentHelper.createFactory();
    private timeoutHandle: number = null;

    constructor(props) {
        super(props)

        this.state = {
            filter: "",
            onlyAssignments: true
        }
    }

    private renderTextBox = () => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.filter;
        props.field.triggerOnChange = true;
        props.onChange = (_, value: string) => {
            this.setState({ filter: value }, () => {
                this.timeoutHandle = window.setTimeout(() => {
                    this.props.onFilterChange(this.state.filter, this.state.onlyAssignments);
                }, 1000);
            })
        }
        return (
            <div style={{ display: "flex", alignItems: "center", marginLeft: "15px" }}>
                <label>{Helper.getTranslation("Standard.Filtern")}</label>
                <div style={{ width: "250px", marginLeft: "15px" }}>
                    <TextBox {...props} />
                </div>
                <Button
                    buttonStyle={{ marginLeft: "5px" }}
                    iconName="times"
                    handleClick={() => {
                        this.setState({ filter: "" }, () => {
                            this.props.onFilterChange(this.state.filter, this.state.onlyAssignments);
                        })
                    }}
                />
            </div>
        );
    }

    private renderCheckBox = () => {
        const props = this.factory.getDefaultCheckBoxProps();
        props.value = this.state.onlyAssignments;
        props.onChange = (_, value: boolean) => {
            this.setState({ onlyAssignments: value }, () => {
                this.props.onFilterChange(this.state.filter, this.state.onlyAssignments);
            })
        }
        return (
            <div style={{ display: "flex", alignItems: "center", marginLeft: "15px" }}>
                <label style={{ paddingRight: "15px" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.OnlyAssignments")}</label>
                <CheckBox {...props} />
            </div>
        );
    }

    private renderButton = (onClick: () => void, icon: string, title: string) => {
        return (
            <>
                <Button
                    buttonStyle={{ marginLeft: "5px" }}
                    iconName={icon}
                    handleClick={onClick}
                    title={title}
                />
            </>
        );
    }

    componentWillUnmount() {
        if (Helper.hasValue(this.timeoutHandle)) {
            clearTimeout(this.timeoutHandle);
        }
    }

    componentDidUpdate() {
        if (Helper.hasValue(this.timeoutHandle))
            clearTimeout(this.timeoutHandle);
    }

    render() {
        return (
            <div style={{ height: "50px", width: "100%", display: "flex", alignItems: "center" }}>
                {this.renderTextBox()}
                {this.renderCheckBox()}
                {this.renderButton(this.props.expandAll, "folder-tree", Helper.getTranslation("MonitorBaum.AlleAufklappen"))}
                {this.renderButton(this.props.collapseAll, "folder", Helper.getTranslation("MonitorBaum.AlleZuklappen"))}
            </div>
        );
    }
}

interface FilterProps {
    onFilterChange: (filter: string, onlyResourcesWithAssignments: boolean) => void;
    expandAll: () => void;
    collapseAll: () => void;
}

interface FilterState {
    filter: string;
    onlyAssignments: boolean;
}

class ItemInfo extends React.Component<{ item: ITreeItem }, any>{

    constructor(props) {
        super(props)
    }

    private renderResourceInfo = () => {
        const resource = this.props.item as TreeResource;
        let assignments = 0;
        const days = resource.AssignedDays.filter((day) => {
            assignments += day.Assignments.length;
            return day.Assignments.length > 0;
        })
        let infoText = Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.ResourceInfo.NoAssignmentsDistributed");
        if (assignments > 0) {
            infoText = Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.ResourceInfo.AssignmentsOverDays").replace("{x1}", assignments.toString()).replace("{x2}", days.length.toString())
        }
        return (
            <div style={{ display: "grid", gridTemplateColumns: "15px repeat(3, 175px) 15px", gridTemplateRows: "50px repeat(5, 30px)", flex: 1 }}>
                <div style={{ gridColumn: "2/5", fontSize: "35px" }}>{resource.Name}</div>
                <div style={{ gridArea: "2/2/3/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Field.Ressource.ressnr")}</div>
                <div style={{ gridArea: "2/3/3/4", display: "flex", alignItems: "center" }}>{resource.ResNo}</div>

                <div style={{ gridArea: "3/2/4/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Einsatz.OGrNrFilter")}</div>
                <div style={{ gridArea: "3/3/4/4", display: "flex", alignItems: "center" }}>{resource.MainGroup}</div>

                <div style={{ gridArea: "4/2/5/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Einsatz.GrNrFilter")}</div>
                <div style={{ gridArea: "4/3/5/4", display: "flex", alignItems: "center" }}>{resource.Group}</div>
                <div style={{ gridArea: "5/2/6/4", display: "flex", alignItems: "center" }}>{infoText}</div>

                <div style={{ gridArea: "6/2/7/4", display: "flex", alignItems: "center" }}>
                    {InfoHelper.generateGoogleLocationLink(resource.Point)}
                </div>
            </div>
        );
    }

    private renderAssignedDay = () => {
        const day = this.props.item as TreeAssignedDay;

        return (
            <div style={{ display: "grid", gridTemplateColumns: "15px 250px 150px 200px 15px", gridTemplateRows: "50px repeat(3, 30px) 10px repeat(8, 30px)", flex: 1 }}>
                <div style={{ gridColumn: "2/5", fontSize: "35px" }}>{kendo.toString(kendo.parseDate(day.Day.toString()), 'd')}</div>

                <div style={{ gridArea: "2/2/3/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Statistik.Verfügbar")}</div>
                <div style={{ gridArea: "2/3/3/4", display: "flex", alignItems: "center" }}>{day.Available ? "✓" : "✘"}</div>

                {Config.settings.flagsAreActive ? (
                    <>
                        <div style={{ gridArea: "3/2/4/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.Flag")}</div>
                        <div style={{ gridArea: "3/3/4/5", display: "flex", alignItems: "center" }}>{(day.Flag || "/")}</div>
                    </>
                ) : <></>}

                <div style={{ gridArea: "4/2/5/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebCRM.Tasks.RecurringTaskHistory.Capacity")}</div>
                <div style={{ gridArea: "4/3/5/4", display: "flex", alignItems: "center" }}>{InfoHelper.convertToTime(day.Capacity)}</div>

                {day.Statistic.CountAssignments > 0 ? this.renderNotEmptyDay(day) : this.renderEmptyDay()}
            </div>
        );
    }

    private renderNotEmptyDay = (day: TreeAssignedDay) => {

        const points = day.Assignments.map(d => d.Point);
        if (day.StartAtHome)
            points.unshift(day.Home);
        if (day.ReturnToHome)
            points.push(day.Home)

        const fullworkTime = day.Statistic.TotalDrivingHours + day.Statistic.TotalWorkingHours;
        let utilizationInfo: string;
        if ((fullworkTime / day.Capacity) > 1) {
            const value = InfoHelper.toFancyString(((fullworkTime / day.Capacity) * 100) - 100);
            utilizationInfo = `(${Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.Overload").replace("{value}", value)})`;
        } else {
            const value = InfoHelper.toFancyString(((fullworkTime / day.Capacity) * 100));
            utilizationInfo = `(${Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.Utilization").replace("{value}", value)})`;
        }

        const [expl1, expl2] = InfoHelper.generateWorkTimeExplanation();

        const assignmentInfo = Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.Assignments").replace("{value}", day.Assignments.length.toString());

        return (
            <>
                <div style={{ gridArea: "6/2/7/3", display: "flex", alignItems: "center" }}>
                    {assignmentInfo}
                </div>
                <div style={{ gridArea: "6/3/7/5", display: "flex", alignItems: "center" }}>{InfoHelper.generateGoogleDirectionLink(points)}</div>


                <div style={{ gridArea: "7/2/8/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.StartAtHome")}</div>
                <div style={{ gridArea: "7/3/8/4", display: "flex", alignItems: "center" }}>{day.StartAtHome ? "✓" : "✘"}</div>

                <div style={{ gridArea: "8/2/9/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.ReturnToHome")}</div>
                <div style={{ gridArea: "8/3/9/4", display: "flex", alignItems: "center" }}>{day.ReturnToHome ? "✓" : "✘"}</div>

                <div style={{ gridArea: "9/2/10/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.Distance")}</div>
                <div style={{ gridArea: "9/3/10/4", display: "flex", alignItems: "center" }}>{InfoHelper.toFancyString(day.Statistic.TotalDistanceKm) + " km"}</div>

                <div style={{ gridArea: "10/2/11/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Day.FullWorkTime")}</div>
                <div style={{ gridArea: "10/3/11/5", display: "flex", alignItems: "center" }}>{InfoHelper.convertToTime(fullworkTime) + ` ${utilizationInfo}`}</div>

                <div style={{ gridArea: "11/2/12/5", display: "flex", alignItems: "center" }}>
                    {InfoHelper.generateWorkingTimeBarChart(day.Statistic.TotalDrivingHours, day.Statistic.TotalWorkingHours, InfoHelper.convertToTime)}
                </div>


                <div style={{ gridArea: "12/2/14/4", display: "flex", alignItems: "center" }}>
                    {expl1}
                </div>

                <div style={{ gridArea: "12/4/14/6", display: "flex", alignItems: "center" }}>
                    {expl2}
                </div>
            </>
        );

    }

    private renderEmptyDay = () => {
        return (
            <>
                <div style={{ gridArea: "6/2/8/5", fontSize: "30px", display: "flex", alignItems: "center" }}>
                    {Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.ResourceInfo.NoAssignmentsDistributed")}
                </div>
            </>
        );
    }

    private renderAssignment = () => {
        const assignment = this.props.item as TreeAssignment;
        const [str, ort, plz, land] = assignment.AddressPostal.split(",");
        return (
            <div style={{
                display: "grid",
                gridTemplateColumns: "15px repeat(4, 150px) 15px",
                gridTemplateRows: `50px 30px ${assignment.DayPart ? "30px" : "0px"} 30px repeat(6, 30px) ${Config.settings.flagsAreActive ? "30px" : "0px"}`,
                flex: 1
            }}>
                <div style={{ gridColumn: "2/7", fontSize: "35px" }}>{assignment.Id}</div>

                <div style={{ gridArea: "2/2/3/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Field.Einsatz.Bemerkung")}</div>
                <div style={{ gridArea: "2/3/3/5", display: "flex", alignItems: "center" }}>{assignment.Title}</div>

                <div style={{ gridArea: "3/2/4/3", display: assignment.DayPart ? "flex" : "none", alignItems: "center" }}>{Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.Details.Part")}</div>
                <div style={{ gridArea: "3/3/4/5", display: assignment.DayPart ? "flex" : "none", alignItems: "center" }}>{assignment.PartNo}/{assignment.PartsCount}</div>

                <div style={{ gridArea: "4/2/5/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("WebSMS.ServiceReport.Abschlussreiter.Arbeitsstunden")}</div>
                <div style={{ gridArea: "4/3/5/4", display: "flex", alignItems: "center" }}>{InfoHelper.convertToTime(assignment.WorkingHours)}</div>

                <div style={{ gridArea: "5/2/6/3", display: "flex", alignItems: "center" }}>{Helper.getTranslation("Adresse.Adresse")}</div>
                <div style={{ gridArea: "5/3/6/6", display: "flex", alignItems: "center" }}>{`${assignment.Address} (${assignment.AdrNr})`}</div>

                <div style={{ gridArea: "6/3/7/5", display: "flex", alignItems: "center" }}>{str}</div>
                <div style={{ gridArea: "7/3/8/5", display: "flex", alignItems: "center" }}>{plz} {ort}</div>
                <div style={{ gridArea: "8/3/9/5", display: "flex", alignItems: "center" }}>{land}</div>

                <div style={{ gridArea: "9/3/10/6", display: "flex", alignItems: "center" }}>
                    {InfoHelper.generateGoogleLocationLink(assignment.Point)}
                </div>

                <div style={{ gridArea: "10/2/11/3", display: Config.settings.flagsAreActive ? "flex" : "none", alignItems: "center" }}>{Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Flags.Flag")}</div>
                <div style={{ gridArea: "10/3/11/4", display: Config.settings.flagsAreActive ? "flex" : "none", alignItems: "center" }}>{(assignment.Flag || "/")}</div>

            </div>
        );
    }

    private renderInfo = () => {
        if (!Helper.hasValue(this.props.item))
            return <></>;
        switch (this.props.item.Type) {
            case TreeType.Resource:
                return this.renderResourceInfo();
            case TreeType.Day:
                return this.renderAssignedDay();
            case TreeType.Assignment:
                return this.renderAssignment();
            default:
                return <></>
        }



    }

    render() {
        return this.renderInfo();
    }
}

class InfoHelper {
    private static distributed_bar_colors = {
        start: "#2962ff",
        end: "#2979ff",
        border: "#0d47a1"
    }

    private static non_distributed_bar_colors = {
        start: "#f44336",
        end: "#d50000",
        border: "#b71c1c"
    }

    private static work_bar_colors = {
        start: "#2979ff",
        end: "#2962ff",
        border: "#0d47a1"
    }

    private static travel_bar_colors = {
        start: "#e64a19",
        end: "#ff7043",
        border: "#d84315"
    }

    public static toFancyString = (value: number) => {
        return value.toLocaleString(navigator.language, {
            minimumIntegerDigits: 2,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            useGrouping: false
        })
    }

    public static convertToTime = (time: number) => {
        const parse = (value: number) => {
            return value.toLocaleString(navigator.language, {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        }

        const hours = Math.floor(time);
        const minutesRaw = time - hours;
        const minutes = Math.round(60 * minutesRaw);
        return parse(hours) + ":" + parse(minutes);
    }

    public static generateDistributedBarChart = (value1: number, value2: number, parse: (value: number) => string) => {
        return InfoHelper.generateBarChart(value1, value2, parse, InfoHelper.distributed_bar_colors, InfoHelper.non_distributed_bar_colors)
    }

    public static generateWorkingTimeBarChart = (value1: number, value2: number, parse: (value: number) => string) => {
        return InfoHelper.generateBarChart(value1, value2, parse, InfoHelper.travel_bar_colors, InfoHelper.work_bar_colors)
    }

    private static generateBarChart = (value1: number, value2: number, parse: (value: number) => string, bar1Colors, bar2Colors) => {
        const generateStyle = (start: string, end: string, border: string, value: number) => {
            let length = ((value * 100) / (value1 + value2));
            length = (length > 0 && length <= 8) ? 8 : length;
            const style: React.CSSProperties = {
                width: `${length}%`,
                border: `1px solid ${border}`,
                backgroundImage: `linear-gradient(to right, ${start}, ${end})`,
                height: "100%",
                color: "#ffffff",
                display: length > 0 ? "flex" : "none",
                alignItems: "center",
                justifyContent: "center"
            }
            return style;
        }

        return (
            <div style={{ width: "100%", height: "30px", display: "flex" }}>
                <div style={generateStyle(bar1Colors.start, bar1Colors.end, bar1Colors.border, value1)}>{parse(value1)}</div>
                <div style={generateStyle(bar2Colors.start, bar2Colors.end, bar2Colors.border, value2)}>{parse(value2)}</div>
            </div>
        );
    }

    public static generateWorkTimeExplanation = () => {
        return [
            InfoHelper.generateExplanation(InfoHelper.travel_bar_colors.start, InfoHelper.travel_bar_colors.end, InfoHelper.travel_bar_colors.border, Helper.getTranslation("Statistik.Reisezeit")),
            InfoHelper.generateExplanation(InfoHelper.work_bar_colors.start, InfoHelper.work_bar_colors.end, InfoHelper.work_bar_colors.border, Helper.getTranslation("WebSMS.WeeklyReport.Arbeitszeit"))
        ];
    }

    public static generateDistributionExplanation = () => {
        return [
            InfoHelper.generateExplanation(InfoHelper.distributed_bar_colors.start, InfoHelper.distributed_bar_colors.end, InfoHelper.distributed_bar_colors.border, Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.Distributed")),
            InfoHelper.generateExplanation(InfoHelper.non_distributed_bar_colors.start, InfoHelper.non_distributed_bar_colors.end, InfoHelper.non_distributed_bar_colors.border, Helper.getTranslation("WebSMS.DistributeAssignments.ResultPreview.General.NotDistributed"))
        ];
    }

    private static generateExplanation = (start: string, end: string, border: string, text: string) => {
        const style: React.CSSProperties = {
            border: `1px solid ${border}`,
            backgroundImage: `linear-gradient(to right, ${start}, ${end})`,
            gridArea: "2/2/3/3"
        };

        return (
            <div style={{ display: "grid", gridTemplateColumns: "10px 30px 10px 1fr", gridTemplateRows: "10px 30px 10px" }}>
                <div style={style} />
                <div style={{ gridArea: "2/4/3/5", display: "flex", alignItems: "center" }}>
                    {text}
                </div>
            </div>
        );
    }

    public static generateGoogleLocationLink = (point: Point) => {
        const isOk = (value: number) => {
            return Helper.hasValue(value) && Helper.isNumber(value) && !isNaN(value);
        }
        if (!isOk(point.Lat) || !isOk(point.Long)) {
            return <></>;
        }
        const onClick = () => {
            //https://developers.google.com/maps/documentation/urls/get-started
            const url = "https://www.google.com/maps/search/?api=1&query=" + point.Lat + "," + point.Long;
            window.open(url, '_blank').focus();
        }
        return (
            <>
                <a onClick={onClick}>{Helper.getTranslation("Standard.OpenInGoogleMaps")}</a>
            </>
        );

    }

    public static generateGoogleDirectionLink = (points: Point[]) => {
        const isOk = (value: number) => {
            return Helper.hasValue(value) && Helper.isNumber(value) && !isNaN(value);
        }

        const getLocation = (point: Point) => {
            if (isOk(point.Lat) && isOk(point.Long)) {
                return `${point.Lat},${point.Long} `;
            }
            return "";
        }

        const onClick = () => {
            //https://developers.google.com/maps/documentation/urls/get-started
            const url = "https://www.google.com/maps/dir/" + points.map(getLocation).join("/");
            window.open(url, '_blank').focus();
        }
        return (
            <>
                <a onClick={onClick}>{Helper.getTranslation("Standard.OpenInGoogleMaps")}</a>
            </>
        );

    }

}